import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from '@polichat/flamboyant';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../store/modules/chat/actions';
import ContactsScreen from './filter/ContactsScreen';
import TriggerSuggestionScreen from './filter/TriggerSuggestion';
import FilterDropdown from './filter/FilterDropdown';
import { ChevronDownLine, ChevronUpLine } from '@poli-digital/react';
import { toast } from 'react-toastify';
import { useEffect, useState, useMemo } from 'react';
import { useFlags } from 'flagsmith/react';
import { customUseFlags } from 'src/hooks/customUseFlags';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function NewTabs({
  openChatTab,
  activeTab,
  openInProgressTab,
  openUnReadsTab,
  activeFilters,
  removeFilter,
  currentPageState,
  fetchMoreChatsRequest,
  searchState,
  clearResultsInSearchChats,
  clearCustomFilterPage,
  submitFilter,
  clearFilter,
  currentUser,
  hasAsyncRequest,
  openNoAttendantTab,
  noAttendantTabActive,
}) {
  const hasOperatorRole = currentUser?.roles?.some(
    (role) => role.name === 'agent'
  );

  const flag = useFlags(['enable_trigger_suggestion']);

  const enable_trigger_suggestion = customUseFlags(
    flag.enable_trigger_suggestion
  );

  const searchValue = searchState.current || '';
  const allCurrentPage = currentPageState?.all?.page;
  const inProgressCurrentPage = currentPageState?.inProgress?.page;
  const unReadsCurrentPage = currentPageState?.unReads?.page;
  const searchPage = currentPageState?.search?.page;
  const filtersActive = activeFilters;

  // Traduções reativas que atualizam quando o idioma muda
  const inServiceText = useGlotaT('spa.chat.inService');
  const allConversationsText = useGlotaT('spa.chat.allConversations');
  const noAttendantText = useGlotaT('spa.chat.noAttendant');
  const unreadText = useGlotaT('spa.chat.unread');

  // nameTab atualiza quando as traduções mudam (mudança de idioma)
  const nameTab = useMemo(() => ({
    inprogress: {
      key: 'inprogress',
      name: inServiceText,
    },
    chat: {
      key: 'chat',
      name: allConversationsText,
    },
    noAttendant: {
      key: 'noAttendant',
      name: noAttendantText,
    },
    unreads: {
      key: 'unreads',
      name: unreadText,
    },
  }), [inServiceText, allConversationsText, noAttendantText, unreadText]);

  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [showNameTab, setShowNameTab] = useState(null);

  /**
   * Effect Hook -
   * verifica qual a aba ativa e se alterou o tipo de filtro de sem atendente
   * para setar o nome do Dropdown
   * Também reage a mudanças nas traduções (mudança de idioma)
   */
  useEffect(() => {
    if (activeTab === 'inprogress') {
      setShowNameTab(nameTab.inprogress.name);
    } else if (noAttendantTabActive) {
      setShowNameTab(nameTab.noAttendant.name);
    } else if (activeTab === 'chat') {
      setShowNameTab(nameTab.chat.name);
    } else if (activeTab === 'unreads') {
      setShowNameTab(nameTab.unreads.name);
    } else {
      // Inicializa com chat se não houver aba ativa
      setShowNameTab(nameTab.chat.name);
    }
  }, [activeTab, activeFilters?.attendant?.length, noAttendantTabActive, nameTab]);

  // Essa variável é usada para identificar algum loading dentro do chat
  // Será utilizada como condicional para permitir um clique ou não
  const somethingIsLoading = hasAsyncRequest;
  // Esta como string, devido que removi o count que fica entre parenteses
  // (${ countNoReads || '0' }) Será feito essa parte em outra sprint.
  const titleTab = showNameTab || nameTab.chat.name;

  let activeFiltersIsFill = false;

  if (
    filtersActive.attendant.length > 0 ||
    filtersActive.date.length > 0 ||
    filtersActive.department.length > 0 ||
    filtersActive.tag.length > 0 ||
    filtersActive.chat.length > 0 ||
    filtersActive.channel.length > 0
  ) {
    activeFiltersIsFill = true;
  }

  let customFilterPage = currentPageState?.customFilter.page;
  let page;

  const onClickTab = (screen) => {
    removeFilter('chat');

    if (
      currentPageState?.customFilter.page &&
      currentPageState?.customFilter.page > 0
    ) {
      // Resetar CustomFilter para começar buscando do início
      clearCustomFilterPage();
      customFilterPage = 0;
    }

    if (screen === 'all') {
      page = allCurrentPage;
    } else if (screen === 'currents') {
      page = inProgressCurrentPage;
    } else if (screen === 'noread') {
      page = unReadsCurrentPage;
    }

    // Validação se o campo de busca está ativo / preenchido
    if (searchValue && searchValue.length > 0 && searchPage) {
      page = searchPage;
    }

    if (customFilterPage >= 0 && activeFiltersIsFill) {
      page = customFilterPage;
    }

    fetchMoreChatsRequest(page, filtersActive, searchValue, screen);
  };

  function handleTabToNoAttendant() {
    handleTab('chat');
    let payload = Object.assign({}, activeFilters);
    try {
      let value = parseInt(-1);
      payload.attendant = [
        {
          value: value,
        },
      ];
      setShowNameTab(nameTab.noAttendant.name);
      submitFilter(payload, 'all');
    } catch {
      payload.attendant = [];
      clearFilter(payload);
    }
  }

  // Variável usada para identificar qual "tabContainer" receberá o estilo de ativo
  function handleTab(nameTab) {
    if (searchValue && searchValue.length > 0) {
      clearResultsInSearchChats();
    }
    switch (nameTab) {
      case 'inprogress':
        onClickTab('currents');
        openInProgressTab();
        break;
      case 'chat':
        onClickTab('all');
        openChatTab();
        break;
      case 'unreads':
        onClickTab('noread');
        openUnReadsTab();
        break;
    }
    // se o filtro de sem atendente estiver ativo ao trocar de aba deve limpar
    // caso tenha outros filtro de atendende deve manter os filtro atuais
    if (noAttendantTabActive) {
      removeFilter('attendant');
    }
  }

  function callHandleFuntion(nameTab) {
    if (nameTab !== 'noAttendant') {
      handleTab(nameTab);
    } else {
      handleTabToNoAttendant();
      openNoAttendantTab();
    }
  }

  return (
    <div className="newTabsPanel">
      <Dropdown
        isOpen={toggleDropdown}
        toggle={() => setToggleDropdown((previous) => !previous)}
        className="newTabDropdown"
      >
        <DropdownToggle className="newTabDropdownToggle">
          <div>
            <span>{titleTab}</span>
            {toggleDropdown ? <ChevronUpLine /> : <ChevronDownLine />}
          </div>
        </DropdownToggle>
        <DropdownMenu className="newTabDropdownMenu">
          <DropdownItem
            className="newTabDropdownItem"
            onClick={() => callHandleFuntion('inprogress')}
          >
            <div className="newTabItem">
              <span>{nameTab.inprogress.name}</span>
            </div>
          </DropdownItem>
          <DropdownItem
            className="newTabDropdownItem"
            onClick={() => callHandleFuntion('chat')}
          >
            <div className="newTabItem">
              <span>{nameTab.chat.name}</span>
            </div>
          </DropdownItem>
          {currentUser?.superRole != 'agent' && (
            <DropdownItem
              className="newTabDropdownItem"
              key={-1}
              value={-1}
              onClick={() => callHandleFuntion('noAttendant')}
            >
              <div className="newTabItem">
                <span>{nameTab.noAttendant.name}</span>
              </div>
            </DropdownItem>
          )}
          <DropdownItem
            className="newTabDropdownItem"
            onClick={() => callHandleFuntion('unreads')}
          >
            <div className="newTabItem">
              <span>{nameTab.unreads.name}</span>
            </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <div className="newTabButtonsFilters">
        {hasOperatorRole && enable_trigger_suggestion && (
          <div className="filterButton">
            <TriggerSuggestionScreen />
          </div>
        )}
        <div className="filterButton">
          <ContactsScreen />
        </div>
        <div className="filterButton">
          <FilterDropdown />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  activeTab: state.chat.config?.activeTabNavigation,
  activeFilters: state.chat?.filters?.activeFilters,
  currentPageState: state.chat?.currentPage,
  searchState: state.chat?.search,
  countNoReads: state.chat?.count_no_read,
  allUsers: state.chat?.config?.general?.users,
  currentUser: state.general.user,
  hasAsyncRequest: state.chat?.hasAsyncRequest,
  noAttendantTabActive: state.chat?.config?.noAttendantTabActive,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openChatTab: ChatActions.openChatTab,
      removeFilter: ChatActions.removeFilter,
      openInProgressTab: ChatActions.openInProgressTab,
      openUnReadsTab: ChatActions.openUnReadsTab,
      openNoAttendantTab: ChatActions.openNoAttendantTab,
      fetchMoreChatsRequest: ChatActions.fetchMoreChatsRequest,
      clearResultsInSearchChats: ChatActions.clearResultsInSearchChats,
      clearCustomFilterPage: ChatActions.clearCustomFilterPage,
      submitFilter: ChatActions.submitFilter,
      clearFilter: ChatActions.clearFilter,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewTabs);
